export default __webpack_public_path__ + "static/media/MoreThan10K.80ac57ea.png";